"use client"

import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { ChevronDown, ShoppingCart } from 'lucide-react'

const doctors = [
  {
    name: "Plastics",
    specialty:
      "Plastics are made from natural materials such as cellulose, coal, natural gas, salt and crude oil through a polymerization or polycondensation process.",
    image: "/images/PVC_Stabilizers.jpg",
    bgColor: "bg-purple-50",
    hash: 'plastics'
  },
  {
    name: "Paints & Coatings",
    specialty:
      "Paint and coating raw materials include pigments for color and opacity, binders (resins) for film formation, solvents for dispersion, and additives for specific properties like durability, corrosion resistance, and drying time.",
    image: "/images/PVC_Resins.jpg",
    bgColor: "bg-purple-50",
    hash: 'paints'
  },
  {
    name: "Polyurethane Chemicals",
    specialty:
      "Key components in flexible and rigid foams, adhesives, sealants, and coatings, widely used in construction, furniture, and automotive industries.",
    image: "/images/HDPE.jpg",
    bgColor: "bg-purple-50",
    hash: 'polyurethane'
  },
  {
    name: "Aluminium Surface Treatment Products",
    specialty:
      "Chemicals used for cleaning, anodizing, and coating aluminum surfaces to enhance corrosion resistance, durability, and aesthetic appeal.",
    image: "/images/Calcium_Carbonate.jpg",
    bgColor: "bg-purple-50",
    hash: 'aluminium'
  },
  {
    name: "Fertilizers & Raw Materials",
    specialty:
      "Essential nutrients and compounds, including nitrogen, phosphorus, and potassium, used to enhance soil fertility and improve agricultural productivity.",
    image: "/images/Reprocessed_HDPE.jpg",
    bgColor: "bg-purple-50",
    hash: 'fertilizer'
  },
  {
    name: "Other Products",
    specialty:
      "Diverse range of industrial chemicals and materials catering to various sectors, including Coal Fly Ash, Cement, Rice, and Spices.",
    image: "/images/Impact_Modifiers_CPE.webp",
    bgColor: "bg-purple-50",
    hash: 'other'
  }
];


// Transform doctors into products
const products = doctors.map((doctor, index) => ({
  id: index + 1,
  name: doctor.name,
  description: doctor.specialty,
  hash: doctor.hash
}))
const formatHash = (name) => name.toLowerCase().replace(/\s+/g, "-");

export function ProductAccordion() {
  const [openIndex, setOpenIndex] = useState(null)

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="w-full max-w-5xl mx-auto p-4">
      <div className="text-center mb-12 md:mb-16">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-blue-600 font-medium block mb-4"
        >
          Our Products
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-4xl md:text-5xl font-bold leading-none"
        >
          What we Offer

        </motion.h2>
      </div>
      <div className="grid grid-cols-1 gap-6">
        {products.map((product, index) => (
          <motion.div
            key={product.id}
            className="border border-gray-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg hover:shadow-blue-300/50 transition-shadow duration-300"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
          >
            <button
              className="flex justify-between items-center w-full p-6 text-left bg-white hover:bg-gray-50 transition-colors"
              onClick={() => toggleAccordion(index)}
            >
              <h3 className="font-semibold text-lg text-gray-800">{product.name}</h3>
              <div className="flex items-center space-x-4">
                {/* <span className="font-bold text-xl text-blue-600">${product.price}</span> */}
                <ChevronDown
                  className={`w-6 h-6 text-gray-800 transition-transform duration-200 ${openIndex === index ? "transform -rotate-180" : "transform -rotate-90"
                    }`}
                />
              </div>
            </button>
            <AnimatePresence>
              {openIndex === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="pt-2 px-6 pb-6 bg-gray-50">
                    <p className="text-gray-600 mb-4">{product.description}</p>
                    <a href={`/product#${product.hash}`}
                      className="w-fit bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors duration-200 flex items-center space-x-2">
                      <ShoppingCart className="w-5 h-5" />
                      <span>View Products</span>
                    </a>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>


    </div>
  )
}
